<template>
  <div>
    <templates-view

    />
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import TemplatesView            from '../../../components/views/TemplatesView.vue'
import useAPI                   from '../../../utils/useAPI'

export default {
  components: { TemplatesView },
  props: {},
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const {
      fetchAutocompleteWorkflows,
      fetchAutocompleteWorkFlos,
      fetchAutocompleteUsers
    } = useAPI()

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    // fetchAutocompleteEmployees()
    // fetchAutocompleteWorkflows()
    // fetchAutocompleteWorkFlos()
    // fetchAutocompleteUsers()

    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>